<template>
  <div>
    <CRow>
      <CCol lg="26">
          <CTableWrapper :items="getDevicesData()" >            
          <template #header>
            <CIcon name="cil-grid"/>Types et micrologiciels
            <div class="card-header-actions">    
            </div>
          </template>
        </CTableWrapper>
      </CCol>
    </CRow>
  </div>
</template>

<script>

//require('dotenv').config()
const APIURL = process.env.VUE_APP_API_URL

import CTableWrapper from './SNprop.vue'
import axios from 'axios'

export default {
  name: 'SNProp',
  data() {
    return {
      loading: true,
      rowSelected: -1,
      info: []
    }
  },  
  components: { 
     CTableWrapper
  },
  mounted() {
       axios.get( APIURL+'/api1/devicestypes', {   
         mode: 'no-cors',
              headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          withCredentials: false
        } )
        .then( res => { 
                this.info = res.data;         
                for (var x=0; x < this.info.length; x++)
                {                   
                  this.info[x].dateFrom =this.$SNFormatDate(this.info[x].dateFrom )
                  this.info[x].dateTo =this.$SNFormatDate(this.info[x].dateTo )
                }
              }
        )
        .catch( err => console.log(err))
        .finally(() => this.loading = false) 
  },
  methods: {
    getDevicesData() {
      return this.info;
    }
    ,
    updateRowSelected( item,row )            
    {
    }  
  }
}

</script>
